import React from 'react'
import Modal from 'react-modal'

const InfoModal = (props) => {
    const [modalIsOpen, setIsOpen] = React.useState(false);

    const customStyles = {
        overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.3)"
        },
        content: {
          top: '60px',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, 0%)',
          boxShadow: '3px 3px 10px rgba(0, 0, 0, 0.2)',
          minWidth: '320px',
          maxWidth: '85%',
          borderRadius: '10px',
        },
    };

    return (
        <div className='inline-block align-middle'>
            <button className='relative rounded-full w-8 h-8 border border-purple-200 bg-white hover:bg-gray-50 mx-2' onClick={() => setIsOpen(true)}>
                <i className='absolute -top-0.5 start-0.5 bi bi-question text-2xl text-purple-500'></i>
            </button>

                <Modal
                    contentLabel="ヘルプ"
                    style={customStyles}
                    isOpen={modalIsOpen}
                >
                    <h2 className='text-2xl mb-2 text-purple-700 me-8'><i className='bi bi-question-circle me-2'></i>ヘルプ</h2>
                    <button onClick={() => setIsOpen(false)} className='absolute top-4 end-4 text-xl text-gray-500'><i className='bi bi-x-lg'></i></button>

                    <hr className='my-4' />
                    
                    {props.children}
                </Modal>
        </div>
    )
}

export default InfoModal